"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ToolboxPanel_1 = __importDefault(require("./ToolboxPanel"));
exports.default = ToolboxPanel_1.default;
